import { FC } from 'react';

import { Stack, Text } from '@eluve/components';

export interface InstructionStepRendererProps {
  step: number;
  title: string;
  imageSrc: string;
  imageAlt: string;
}

export const InstructionStepRenderer: FC<InstructionStepRendererProps> = ({
  step,
  title,
  imageSrc,
  imageAlt,
}) => (
  <Stack
    gap={8}
    className="rounded-lg bg-bg-tertiary py-3 pr-3 pl-7"
    direction="horizontal"
  >
    <Stack gap={1} className="flex-1" fullWidth={false}>
      <Text inline size="md" weight="bold" color="secondary">
        Step {step}
      </Text>
      <Text inline size="xs" weight="semibold" color="tertiary">
        {title}
      </Text>
    </Stack>
    <img
      src={imageSrc}
      alt={imageAlt}
      className="h-auto w-[200px] shrink-0 rounded-sm border border-border-primary"
    />
  </Stack>
);
